import { render, staticRenderFns } from "./CustomFieldsLead.vue?vue&type=template&id=58179481"
import script from "./CustomFieldsLead.vue?vue&type=script&lang=js"
export * from "./CustomFieldsLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports